import { inject, singleton } from 'tsyringe';
import ConfigurationManager from '../../infra/configuration/ConfigurationManager';
import { AbstractRepository } from '../../core/repositories/AbstractRepository';
import { AuthTokenStorageType } from './types';
import ShellLocalStorageDAOImpl from '../../dao/ShellLocalStorageDAOImpl';
import ShellInMemoryDAOImpl from '../../dao/ShellInMemoryDAOImpl';
import { internalLogger } from '../../interface/v1/clientOsLogger';

@singleton()
class AuthTokenRepository extends AbstractRepository<AuthTokenStorageType> {
  public static _prefixKey = 'jshellAuthToken';

  constructor(
    @inject(ShellLocalStorageDAOImpl)
    shellLocalStorageDAOImpl: ShellLocalStorageDAOImpl,
    @inject(ShellInMemoryDAOImpl)
    shellInMemoryDAOImpl: ShellInMemoryDAOImpl
  ) {
    const isNative = ConfigurationManager.getProps('isNative');
    super({
      shellDAO: isNative ? shellInMemoryDAOImpl : shellLocalStorageDAOImpl,
      prefixKey: AuthTokenRepository._prefixKey
    });
  }

  saveAll(): void {
    /* istanbul ignore next */
    internalLogger?.debug?.d5?.({
      className: 'AuthTokenRepository',
      methodName: 'saveAll()',
      message: 'Not supported in AuthTokenRepository.'
    });
    throw new Error('Method not implemented.');
  }

  findAll(): AuthTokenStorageType[] {
    /* istanbul ignore next */
    internalLogger?.debug?.d5?.({
      className: 'AuthTokenRepository',
      methodName: 'findAll()',
      message: 'Not supported in AuthTokenRepository.'
    });
    throw new Error('Method not implemented.');
  }
}

export default AuthTokenRepository;
